module.exports = __webpack_public_path__ + "images/banners/pasodash/note_pc_dash_banner_sp_06d0843dfca3ed5ba009fce38c030d7a.png";